import React from "react";
import { Box, Typography } from "@mui/material";

// Empty-state block with a small inline illustration, replacing bare icon+text empty states.
export const EmptyState = ({ title, subtitle, darkMode, accent }) => {
  const stroke = darkMode ? '#24304A' : '#D8E1E8';
  const fill = darkMode ? '#0E1626' : '#EAF0F4';
  const accentColor = accent || (darkMode ? '#2FE4D6' : '#0C8599');
  return (
    <Box sx={{ textAlign: 'center', py: 8 }}>
      <svg width="120" height="90" viewBox="0 0 120 90" fill="none" style={{ marginBottom: 16 }}>
        <rect x="10" y="18" width="100" height="62" rx="8" fill={fill} stroke={stroke} strokeWidth="2" />
        <rect x="24" y="34" width="56" height="8" rx="4" fill={stroke} />
        <rect x="24" y="50" width="72" height="6" rx="3" fill={stroke} opacity="0.6" />
        <rect x="24" y="62" width="40" height="6" rx="3" fill={stroke} opacity="0.6" />
        <circle cx="94" cy="26" r="10" fill={accentColor} opacity="0.15" />
        <path d="M90 26h8M94 22v8" stroke={accentColor} strokeWidth="2" strokeLinecap="round" />
      </svg>
      <Typography variant="h6" sx={{ color: darkMode ? '#EAF3FB' : 'text.secondary', mb: 1 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" sx={{ color: darkMode ? '#93A2BC' : 'text.disabled' }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default EmptyState;
